import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  invokeEvent: Subject<any> = new Subject();
  showSidebar = false;

  constructor() {}

  setMainLayoutSelectedTab(route) {
    this.invokeEvent.next({
      action: 'set-main-layout-selected-tab',
      value: route,
    });
  }

  setShowSidebar(value) {
    this.showSidebar = value;
    this.invokeEvent.next({
      action: 'set-show-sidebar',
      value: value,
    });
  }

  callAllProducts() {
    this.invokeEvent.next('call-all-products');
  }

  callAllBusinesses() {
    this.invokeEvent.next('call-all-businesses');
  }

  callAllBranches() {
    this.invokeEvent.next('call-all-branches');
  }

  callAllTables() {
    this.invokeEvent.next('call-all-tables');
  }

  callAllTeamMembers() {
    this.invokeEvent.next('call-all-team-members');
  }

  callAllThirdParties() {
    this.invokeEvent.next('call-all-third-party');
  }

  callAllBusinessCategories() {
    this.invokeEvent.next('call-all-business-categories');
  }

  addedToCart() {
    this.invokeEvent.next('added-to-cart');
  }

  callOrderDeleted(order) {
    this.invokeEvent.next({ action: 'order-deleted', value: order });
  }
}
